import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { StyledContainer } from '../UnavailableSeat.styles';
import { StyledWrapper, StyledText, StyledBookingSeat, StyledSeatsContent } from './UnavailablebyBooking.styles';

const UnavailableByBooking = ({ seats }) => (
  <StyledContainer data-testid="unavailable-booking">
    <StyledWrapper>
      <StyledText>
        <FormattedMessage id="unavailableSeats.bookingSeats" />{' '}
      </StyledText>
      <div>
        {Object.entries(seats).map(([reference, seat]) => (
          <StyledSeatsContent key={`${reference}-${seat}`}>
            <StyledBookingSeat data-cy="link-to-booking">
              <Link
                to={{
                  pathname: `/manage/bookings/${reference}/journeys`
                }}
                target="_blank"
              >
                {reference}:{' '}
              </Link>
            </StyledBookingSeat>
            <strong>{`${seat}`}</strong>
          </StyledSeatsContent>
        ))}
      </div>
    </StyledWrapper>
  </StyledContainer>
);

UnavailableByBooking.propTypes = {
  seats: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
};

export default UnavailableByBooking;
